import { render, staticRenderFns } from "./ChooseLanguage.vue?vue&type=template&id=d5ad20d4"
import script from "./ChooseLanguage.vue?vue&type=script&lang=js"
export * from "./ChooseLanguage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports